import React from 'react';
import { css } from 'emotion';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import { TreeSelect as DesignTreeSelect } from '@whalecloud/fdx';
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";
import { makeEventProps } from '@whalecloud/page-builder-core/utils/common';

const left = css({ textAlign: 'left' });
const TreeSelect = props => {
  const { element, nameSpace } = props;
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { horizontalAlign = 'left' } = settings;
  const { treeData, autoInitialize, treeNodeFilterProp } = formItemSettings;
  const eventProps = makeEventProps(element.data.events, nameSpace);
  const flatData = []

  function getFlat(arr){
    if(arr.length){
      arr.map(item=>{
        flatData.push({...item})
        if(item.children?.length){
          const titles=item.titles?[...item.titles]:[item[treeNodeFilterProp]]
          getFlat(item.children.map(ele=>({...ele,titles:[...titles,ele[treeNodeFilterProp]]})))
        }
      })
    }
  }
  getFlat(treeData)

  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <div style={{ textAlign: horizontalAlign }}>
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-input', left)}
            {...formSettings}
          >
            <DesignTreeSelect
              filterTreeNode={(input, option) => {
                if(option.props[treeNodeFilterProp]===null||option.props[treeNodeFilterProp]===undefined){
                  return true
                }
                const titles=flatData.find(item=>item.key===option.key).titles||[flatData.find(item=>item.key===option.key)[treeNodeFilterProp]]
                return titles.some(item=>item.toLowerCase().indexOf(input.toLowerCase())>=0)
              }}
              style={elementStyle} 
              {...formItemSettings} 
              className={className} 
              treeData={autoInitialize ? treeData : []} 
              {...eventProps} 
            />
          </FormItem>
        </div>
      )}
    </ElementRoot>
  );
};

export default TreeSelect;